import React, { useState, useEffect } from 'react';

// 8 frames — hand sweeps clockwise: 12 → 1:30 → 3 → 4:30 → 6 → 7:30 → 9 → 10:30
const FRAMES = [
  // Frame 0: 12 o'clock
  [
    '    _    ',
    '   (o)   ',
    ' .-----. ',
    '/       \\',
    '|   |   |',
    '|   *   |',
    '|       |',
    ' \\_____/ ',
    " '-----' ",
  ],
  // Frame 1: ~1:30 (upper-right)
  [
    '    _    ',
    '   (o)   ',
    ' .-----. ',
    '/       \\',
    '|     / |',
    '|   *   |',
    '|       |',
    ' \\_____/ ',
    " '-----' ",
  ],
  // Frame 2: 3 o'clock (right)
  [
    '    _    ',
    '   (o)   ',
    ' .-----. ',
    '/       \\',
    '|       |',
    '|   *---|',
    '|       |',
    ' \\_____/ ',
    " '-----' ",
  ],
  // Frame 3: ~4:30 (lower-right)
  [
    '    _    ',
    '   (o)   ',
    ' .-----. ',
    '/       \\',
    '|       |',
    '|   *   |',
    '|     \\ |',
    ' \\_____/ ',
    " '-----' ",
  ],
  // Frame 4: 6 o'clock (down)
  [
    '    _    ',
    '   (o)   ',
    ' .-----. ',
    '/       \\',
    '|       |',
    '|   *   |',
    '|   |   |',
    ' \\_____/ ',
    " '-----' ",
  ],
  // Frame 5: ~7:30 (lower-left)
  [
    '    _    ',
    '   (o)   ',
    ' .-----. ',
    '/       \\',
    '|       |',
    '|   *   |',
    '|  /    |',
    ' \\_____/ ',
    " '-----' ",
  ],
  // Frame 6: 9 o'clock (left)
  [
    '    _    ',
    '   (o)   ',
    ' .-----. ',
    '/       \\',
    '|       |',
    '|---*   |',
    '|       |',
    ' \\_____/ ',
    " '-----' ",
  ],
  // Frame 7: ~10:30 (upper-left)
  [
    '    _    ',
    '   (o)   ',
    ' .-----. ',
    '/       \\',
    '|  \\    |',
    '|   *   |',
    '|       |',
    ' \\_____/ ',
    " '-----' ",
  ],
];

const THEME_COLORS = {
  light:         { color: '#ff6f61', textShadow: 'none' },
  dark:          { color: '#00d4ff', textShadow: '0 0 10px rgba(0, 212, 255, 0.5)' },
  ascii:         { color: '#33ff33', textShadow: '0 0 8px rgba(51, 255, 51, 0.6)' },
  'ascii-light': { color: '#1a1a1a', textShadow: 'none' },
};

const AsciiStopwatch = ({ theme = 'light' }) => {
  const [frame, setFrame] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setFrame(f => (f + 1) % FRAMES.length), 200);
    return () => clearInterval(id);
  }, []);

  const { color, textShadow } = THEME_COLORS[theme] ?? THEME_COLORS.light;

  return (
    <pre
      style={{
        fontFamily: '"Courier New", Courier, monospace',
        fontSize: '1.3rem',
        lineHeight: '1.5',
        color,
        textShadow,
        margin: '0',
        userSelect: 'none',
        textAlign: 'left',
        letterSpacing: '0.05em',
      }}
    >
      {FRAMES[frame].join('\n')}
    </pre>
  );
};

export default AsciiStopwatch;
